import { CANDIDATEEDUCATION } from "../ENVIRONMENT";

function educationList(token) {
  // api for candidate education list
  const response = fetch(CANDIDATEEDUCATION, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}
export { educationList };
